(ns hai.admin-ui.users.contacts.edit
  "Sidebar route for editing an existing contact."
  (:require
   [hai.entity.helpers :as entity]
   [hai.admin-ui.users.contacts.form :as contacts.form]
   [hai.ui.components :as c]
   [hai.ui.rf-sugar :refer [<s >e defevent-fx defsub]]
   [hai.web-app.layout :as layout]))

(defsub :contact/by-uuid
  [db id]
  (let [id (-> (or id (get-in db [:routing/current-route :path-params :contact/uuid]))
               (uuid))]
    (get-in db [:contact/uuid id])))

;; Resolve the contact WITHOUT `:user.entity/permissions`. The generic
;; `:entity/resolve` appends that attr, but its resolver THROWS for contacts
;; (they're owned via `:contact/owner`, not a shareable group), which fails the
;; whole entity → blank page. We only need the contact's own fields (incl
;; `:contact/tags`), so resolve with the model pull-query directly.
(defevent-fx ::resolve [_ contact]
  (let [ident (entity/->ident contact)]
    {:resolve {:query        [{ident (entity/->pull-query contact)}]
               :transform-fn (fn [res] (get res ident))
               :store-in     ident}}))

;; Callers that send someone here from elsewhere (a note's contact chip, say)
;; pass `?return-to=<path>`; save and cancel then go back there rather than
;; dumping them on the contacts table.
(defn- leave-fx
  [return-to]
  (if (not-empty return-to)
    [:routing/navigate-to-path return-to]
    [:routing/navigate [:contacts/table]]))

(defn page
  [_]
  (when-let [contact @(<s :contact/by-uuid)]
    (let [return-to (:return-to @(<s [:routing/query-params]))
          leave     (leave-fx return-to)]
      [layout/page
       [layout/title-bar [c/Heading (or (:contact/full-name contact) "Edit contact")]]
       [layout/content
        [contacts.form/contact-form
         {:form-id       ::edit
          :initial-value contact
          :initial-tags  (:contact/tags contact)
          :submit-label  "Save"
          :on-success-fx [[:dispatch leave]]
          :on-cancel     #(>e leave)}]]])))

(defn routes
  []
  [["/edit/{contact/uuid}"
    {:name  :contacts/edit
     :label "Edit contact"
     :view  page
     :controllers [{:parameters {:path [:contact/uuid]}
                    :start (fn [{contact :path}]
                             (>e [::resolve contact]))}]}]])
